import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PolizaKNetworking2026 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/110526-Poliza-de-Servicios_K-Networking_X440_24P-5320-24P.pdf`;
  /*const pdfUrl = "/pdf/110526-Poliza-de-Servicios_K-Networking_X440_24P-5320-24P.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Póliza 2026</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Póliza 2026" />
      </Container>
    </>
  );
};

 export default PolizaKNetworking2026;
